import type { LegitimateAny } from "@kivra/sdk/types/util";

export function isPromise(obj: LegitimateAny): obj is Promise<unknown> {
  return Boolean(obj && typeof obj.then == "function");
}
